import { render, staticRenderFns } from "./MyRecipes.vue?vue&type=template&id=2250af94&"
import script from "./MyRecipes.vue?vue&type=script&lang=js&"
export * from "./MyRecipes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports